import { put, takeEvery } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { fetchCommonData } from "../../slices/common";
import type { ResponseGenerator } from "./shared";

export * from "./shared";

/**
 * WEB half of `commonSaga` — see `shared.ts` for the two divergences from mobile.
 *
 * ⚠️ Both core imports name the VARIANT, not the folder (hazard 6/16): this file knows it is the
 * web build, so it must bind to web's axios instance and web's `common` slice rather than let
 * `moduleSuffixes` decide.
 *
 * use when only one callback or action or both is needed
 */
function* commonAPICall(data: any) {
  let { payload } = data;
  if (payload.method) {
    try {
      const response: ResponseGenerator = yield api.request({
        method: payload.method,
        url: payload.url,
        data: payload.body || {},
        hideLoader: payload.hideLoader,
        // WEB ONLY — mobile does not send this field.
        skipGlobalLoader: payload.skipGlobalLoader,
      } as any);
      if (payload.action) {
        yield put(payload.action(response));
      }
      if (payload.callback) {
        yield payload.callback(response);
      }
    } catch (error: any) {
      // WEB ONLY — mobile has no normalisation and no `|| error.data` fallback.
      error = error || {};
      console.log(error);
      if (payload.errorCallback) yield payload.callback(error.response || error.data);
    }
  }
}

export default function* root() {
  yield takeEvery(fetchCommonData.type, commonAPICall);
}
